var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:cancel",
    clipPath: "url(#clip0_7050_70173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.035 13.096C10.7853 14.0856 9.21557 14.5815 7.62419 14.4893C6.03281 14.3972 4.53076 13.7236 3.4036 12.5964C2.27644 11.4692 1.60276 9.96719 1.51065 8.37581C1.41854 6.78443 1.91441 5.21468 2.904 3.965L12.035 13.096ZM13.096 12.036L3.965 2.903C5.21468 1.91341 6.78443 1.41754 8.37581 1.50965C9.96719 1.60176 11.4692 2.27544 12.5964 3.4026C13.7236 4.52976 14.3972 6.03181 14.4893 7.62319C14.5815 9.21457 14.0856 10.7843 13.096 12.034V12.036ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8Z",
    fill: "#D81717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7050_70173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.9daa3c5e9c8636d54a4bbfeff42f037c.svg";
export { ForwardRef as ReactComponent };